import React from "react";

import "./App.css";

import Header from "./Pages/Header/Index";
import ConnectPage from "./Pages/Connectpage/Exchange";
import Pages from "./Pages/Connectpage/Liquidity";
import Addliquidity from "./Sections/AddLiquidity/Index";
import Importpool from "./Sections/Importpool/Index";
import AddLiquiditySupply from "./Sections/AddLiquiditySupply/Index";
import Removeliquidity from "./Sections/Removeliquidity/Index";
import Error from "./Pages/Error/Index";

import { Route, Switch } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <Switch>
        <Route exact path="/" component={Header} />
        <Route path="/swap" component={ConnectPage} />
        <Route path="/addliquidity" component={Addliquidity} />
        <Route path="/importpool" component={Importpool} />
        <Route path="/liquidity" component={Pages} />
        <Route path="/supply" component={AddLiquiditySupply} />
        <Route path="/removeliquidity" component={Removeliquidity} />
        <Route component={Error} />
      </Switch>
    </div>
  );
}

export default App;
